<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardHeader>
          <strong>Υπεργολάβος:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Edit Subcontractor id:  {{ $route.params.id }}
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput label="Ονοματεπώνυμο" addLabelClasses="requiredLabel" type="text" id="name" placeholder="Ονοματεπώνυμο" v-model="name" horizontal></CInput>
              <CTextarea id="activity" addLabelClasses="requiredLabel" label="Δραστηριότητα" placeholder="Δραστηριότητα" v-model="activity" horizontal></CTextarea>
              <CInput label="Τηλέφωνο" type="text" id="phone" placeholder="Τηλέφωνο" v-model="phone" horizontal></CInput>
              <CInput label="Email" type="email" id="email" placeholder="Email" v-model="email" horizontal></CInput>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="12" xl="6">
      <CCard>
        <CCardHeader>
          <strong>Οικονομικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput horizontal type="text" addLabelClasses="requiredLabel" label="ΑΦΜ" id="afm" placeholder="ΑΦΜ" v-model="afm"></CInput>
            <CInput horizontal type="text" label="ΔΟΥ" id="doy" placeholder="ΔΟΥ" v-model="doy"></CInput>
            <CInput horizontal type="text" label="Επάγγελμα" id="profession" placeholder="Επάγγελμα" v-model="profession"></CInput>
            <CInput horizontal type="text" label="Ταχυδρομικός κώδικας" id="tk" placeholder="Ταχυδρομικός κώδικας" v-model="tk"></CInput>
            <CTextarea
                label="Άλλες Πληροφορίες / Σχόλια"
                placeholder="Άλλες Πληροφορίες / Σχόλια"
                horizontal
                rows="9"
                v-model="notes"
            />
            <CButton color="primary" @click="update()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'EditSubcontractor',
  props: {
    caption: {
      type: String,
      default: 'Subcontractor id'
    },
  },
  data: () => {
    return {
        title: '',
        name: '',
        phone: '',
        email: '',
        activity: '',
        doy: '',
        afm: '',
        notes: '',
        profession: '',
        tk: '',
        showMessage: false,
        alertIsShown: false,
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/subcontractors'})
    },
    update() {
        let self = this;
        axios.post('/api/subcontractors/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            name: self.name,
            phone: self.phone,
            email: self.email,
            activity: self.activity,
            doy: self.doy,
            afm: self.afm,
            profession: self.profession,
            tk: self.tk,
            notes: self.notes,
        })
        .then(function (response) {
            self.message = 'Επιτυχής επεξεργασία υπεργολάβου.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get('/api/subcontractors/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
        self.name = response.data.subcontractor.name;
        self.phone = response.data.subcontractor.phone;
        self.email = response.data.subcontractor.email;
        self.activity = response.data.subcontractor.activity;
        self.doy = response.data.subcontractor.doy;
        self.afm = response.data.subcontractor.afm;
        self.profession = response.data.subcontractor.profession;
        self.tk = response.data.subcontractor.tk;
        self.notes = response.data.subcontractor.notes;

        self.title = self.name;
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}
</script>
